import { HUB_CHANNEL_TYPE_QUERY_PARAM, HUB_TAB_QUERY_PARAM } from "@/dashboard/lib/hub/tab";
import { HubTab } from "@/dashboard/types/hub";

const SELF_SERVE_SETUP_BASE = "/self-serve/setup";

export const SELF_SERVE_SETUP_ROUTES = {
  BASE: SELF_SERVE_SETUP_BASE,
  VOIP: `${SELF_SERVE_SETUP_BASE}/voip`,
  TEAM: `${SELF_SERVE_SETUP_BASE}/team`,
  CALL_RUBRIC_GROUP: `${SELF_SERVE_SETUP_BASE}/call-rubric-group`,
  CALL_RUBRIC_LEAD: `${SELF_SERVE_SETUP_BASE}/call-rubric/lead`,
  CALL_RUBRIC_NON_LEAD: `${SELF_SERVE_SETUP_BASE}/call-rubric/non-lead`,
} as const;

export const DASHBOARD_ROUTES = {
  ANALYTICS: "/dashboard/analytics",
  ANALYTICS_INBOUND: "/dashboard/analytics/inbound",
  ANALYTICS_CAMPAIGNS: "/dashboard/analytics/campaigns",
  ANALYTICS_EXPLORER: "/dashboard/analytics/explorer",
  ANALYTICS_OPERATIONAL: "/dashboard/analytics/operational",
  CALL_SCORING: "/dashboard/call-scoring/review",
  CALL_SCORING_LEADERBOARD: "/dashboard/call-scoring/leaderboard",
  CALL_SCORING_TEAM: "/dashboard/call-scoring/team",
  CALL_SCORING_USER: "/dashboard/call-scoring/user",
  UTILIZATION: "/dashboard/utilization",
  DASHBOARD: "/dashboard",
  EMERGENCY: "/dashboard/emergency",
  EMERGENCY_CASES: "/dashboard/emergency/cases",
  EMERGENCY_MANAGE: "/dashboard/emergency/manage",
  HUB_ALL: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.ALL}`,
  HUB_FLAGGED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.FLAGGED}`,
  HUB_NEW_CUSTOMER: "/dashboard/hub/new-customer",
  HUB_RESOLVED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.RESOLVED}`,
  HUB_TRANSFERRED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.TRANSFERRED}`,
  HUB_TRANSFERRED_INTERNAL: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.TRANSFERRED_INTERNAL}`,
  HUB: `/dashboard/hub`,
  MARKETING: "/dashboard/marketing",
  MARKETING_CAMPAIGNS: "/dashboard/marketing/campaigns",
  MARKETING_CAMPAIGNS_CREATE: "/dashboard/marketing/campaigns/create",
  MARKETING_CAMPAIGNS_BUILDER: "/dashboard/marketing/campaigns/create/builder",
  MARKETING_EVENT_TRIGGERS_CREATE: "/dashboard/marketing/event-triggers/create",
  SETTINGS: "/dashboard/settings",
  SETTINGS_TRANSFERS: "/dashboard/settings/transfers",
  SETTINGS_HOURS: "/dashboard/settings/hours",
  SETTINGS_HOLIDAY: "/dashboard/settings/holiday",
  SETTINGS_MEMBERS: "/dashboard/settings/members",
  SETTINGS_UTILIZATION: "/dashboard/settings/utilization",
  SETTINGS_EXPORT_REPORTS: "/dashboard/settings/export-reports",
  SETTINGS_AUDIT_TRAIL: "/dashboard/settings/audit-trail",
  CALL_RUBRIC_GROUPS: "/dashboard/call-rubric-groups",
  GREENHOUSE: "/dashboard/greenhouse",
  GREENHOUSE_QUEUE: "/dashboard/greenhouse/queue",
  GREENHOUSE_SETTINGS: "/dashboard/greenhouse/settings",
  GREENHOUSE_CUSTOMER: "/dashboard/greenhouse/customer",
  GREENHOUSE_OPPORTUNITY: "/dashboard/greenhouse/opportunity",
  PRICING: "/dashboard/pricing",
  REPORT_LOG: "/dashboard/report-log",
  MEMBERS: "/dashboard/members",
  SIGN_IN: "/sign-in",
  SWITCH_TENANT: "/dashboard/switch-tenant",
} as const;

export const DYNAMIC_DASHBOARD_ROUTES = {
  CALL_SCORING_USER: (userId: string) => `${DASHBOARD_ROUTES.CALL_SCORING_USER}/${userId}`,
  CALL_RUBRIC_GROUP: (groupId: string) => `${DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}`,
  CALL_RUBRIC_GROUP_RUBRIC: (groupId: string, rubricId: string) =>
    `${DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}/rubrics/${rubricId}`,
  CALL_RUBRIC_GROUP_NEW_RUBRIC: (groupId: string, classification: "lead" | "non-lead") =>
    `${DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS}/${groupId}/rubrics/new?classification=${classification}`,
  GREENHOUSE_CUSTOMER: (endUserId: string) =>
    `${DASHBOARD_ROUTES.GREENHOUSE_CUSTOMER}/${endUserId}`,
  GREENHOUSE_OPPORTUNITY: (opportunityId: string) =>
    `${DASHBOARD_ROUTES.GREENHOUSE_OPPORTUNITY}/${opportunityId}`,
  HUB: (tab: HubTab) => `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${tab}`,
  HUB_CUSTOMER: (customerId: string, tab?: HubTab, channelType?: "messages" | "calls") => {
    const params = new URLSearchParams();
    if (tab) {
      params.set(HUB_TAB_QUERY_PARAM, tab);
    }
    if (channelType) {
      params.set(HUB_CHANNEL_TYPE_QUERY_PARAM, channelType);
    }

    const queryString = params.toString();
    return `/dashboard/hub/${customerId}${queryString ? `?${queryString}` : ""}`;
  },
  MARKETING_CAMPAIGN: (campaignId: string) =>
    `${DASHBOARD_ROUTES.MARKETING_CAMPAIGNS}/${campaignId}`,
} as const;

export const MULTI_TENANT_VIEW_ROUTE_WHITELIST = [
  DASHBOARD_ROUTES.HUB,
  DASHBOARD_ROUTES.ANALYTICS,
  DASHBOARD_ROUTES.GREENHOUSE,
];

export const SELF_SERVE_ROUTE_WHITELIST = [
  DASHBOARD_ROUTES.CALL_SCORING,
  DASHBOARD_ROUTES.CALL_SCORING_LEADERBOARD,
  DASHBOARD_ROUTES.CALL_SCORING_TEAM,
  DASHBOARD_ROUTES.CALL_SCORING_USER,
  DASHBOARD_ROUTES.CALL_RUBRIC_GROUPS,
  DASHBOARD_ROUTES.PRICING,
  SELF_SERVE_SETUP_ROUTES.VOIP,
  SELF_SERVE_SETUP_ROUTES.TEAM,
  SELF_SERVE_SETUP_ROUTES.CALL_RUBRIC_GROUP,
  SELF_SERVE_SETUP_ROUTES.CALL_RUBRIC_LEAD,
  SELF_SERVE_SETUP_ROUTES.CALL_RUBRIC_NON_LEAD,
];
